module.exports = __webpack_public_path__ + "static/media/promotional_4.f6d06bab.png";